import ServiceExec from '@/common/utils/ServiceExec';
import { admin_couponAPI } from '@/common/service/ApiList';
import router from '@/router';
import { asFormData } from '@/common/utils/ServiceSupport';
import store from '@/store';

export default {
  // 상점관리자 - 쿠폰 발급관리 리스트
  async couponIssueList({ commit, state }, payload) {
    const { page, totalPage, limit } = state;
    if (page > totalPage) return;

    const { data, status } = await ServiceExec.get(admin_couponAPI.issue_list, {
      page,
      limit,
      ...payload
    });

    const { pageInfo, list } = data;

    commit('setPage', page + 1);
    commit('setTotalPage', pageInfo?.totalPage ?? 2);
    commit('setList', list ?? []);
  },

  async couponIssueHistorySearch({ commit, state }, payload) {
    const { page, totalPage, limit } = state;
    if (page > 1) {
      commit('setPageInit');
      commit('setListInit');
      const { page, totalPage, limit } = state;
      const { data, status } = await ServiceExec.get(
        admin_couponAPI.issue_history,
        { page, limit, ...payload }
      );

      const { pageInfo, list } = data;
      commit('setPage', page + 1);
      commit('setTotalPage', pageInfo?.totalPage ?? 2);
      commit('setList', list ?? []);
    } else {
      const { page, totalPage, limit } = state;
      const { data, status } = await ServiceExec.get(
        admin_couponAPI.issue_history,
        { page, limit, ...payload }
      );

      const { pageInfo, list } = data;

      commit('setPage', page + 1);
      commit('setTotalPage', pageInfo?.totalPage ?? 2);
      commit('setList', list ?? []);
    }
  },

  async couponIssueHistoryList({ commit, state }, payload) {
    const { page, totalPage, limit } = state;
    if (page > totalPage) return;

    const { data, status } = await ServiceExec.get(
      admin_couponAPI.issue_history,
      { page, limit, ...payload }
    );

    const { pageInfo, list } = data;

    commit('setPage', page + 1);
    commit('setTotalPage', pageInfo?.totalPage ?? 2);
    commit('setList', list ?? []);
  },

  // 상점관리자 - 쿠폰 저장
  async save({ commit, state }, payload) {
    const { data, status } = await ServiceExec.post(
      admin_couponAPI.coupon_save,
      asFormData(payload)
    );
    if (status === 200) {
      const { userNo } = store.getters['user/getUserData'];
      await store.dispatch('admin_coupon/couponIssueList', { userNo });
      await router.replace('/shop/manage/issue/list');
    }
  },

  // 상점관리자 - 쿠폰 저장
  async issue({ commit, state }, payload) {
    const { data, status } = await ServiceExec.post(
      admin_couponAPI.coupon_issue,
      payload
    );
    if (status === 200) await router.go(-1);
  },

  // 상점관리자 - 쿠폰 삭제
  async delete({ commit, state }, couponNo) {
    const { data, status } = await ServiceExec.delete(
      admin_couponAPI.coupon_delete(couponNo)
    );
    if (status === 200) return data;
    return false;
  }
};
